/**
 * Scroll Actions
 */
import {SET_GO_SCROLL_TOP} from "Actions/types";

export const setGoScrollTop = (data) => ({
    type: SET_GO_SCROLL_TOP,
    payload: data
});